import React, { useContext, useState, useEffect } from "react";
import { BrowserRouter, Link, Route, Routes } from "react-router-dom";
import { GlobalState } from "./Globalstate";
import Users from "./Pages/Users";
import Dashboard from "./Pages/Dashboard";
import Deposits from "./Pages/Deposits";
import Investments from "./Pages/Investments";
import Withdrawal from "./Pages/Withdrawal";
import Login from "./Login";

import "./App.css"

function App() {
  return (
    <>
      <GlobalState>
        <BrowserRouter>
          <Routes>

            <Route exact path="/" element={<Dashboard />} />
            <Route exact path="/users" element={<Users />} />
            <Route exact path="/deposits" element={<Deposits />} />
            <Route exact path="/withdrawals" element={<Withdrawal />} />
            <Route exact path="/investments" element={<Investments />} />
            <Route exact path="/login" element={<Login />} />
          </Routes>
        </BrowserRouter>
      </GlobalState>
    </>
  );
}

export default App;
